import React, { Fragment } from "react";

export function Blog() {
  return (
    <Fragment>
      <h1>Blog</h1>
    </Fragment>
  );
}
